import {
  REQUESTED_FEATURE_LIST,
  REQUESTED_FEATURE_LIST_SUCCEEDED,
  REQUESTED_FEATURE_LIST_FAILED,
} from "./types"

export const requestFeatureList = config => {
  return { type: REQUESTED_FEATURE_LIST, config }
}

export const requestFeatureListSuccess = (action, response) => {
  return { type: REQUESTED_FEATURE_LIST_SUCCEEDED, action, response }
}

export const requestFeatureListError = (action, error) => {
  return { type: REQUESTED_FEATURE_LIST_FAILED, action, error }
}
